import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid var(--current-header-footer);
  border-top: 5px solid var(--current-link);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

function Loading() {
  const { darkMode } = useTheme();
  
  return (
    <LoadingWrapper className={darkMode ? 'dark-mode' : 'light-mode'}>
      <Spinner />
    </LoadingWrapper>
  );
}

export default Loading; 